import { createSelector } from "reselect";
import getShowFullscreenCuepointPreviews from "./getShowFullscreenCuepointPreviews";

export default createSelector(
  [getShowFullscreenCuepointPreviews],
  (showFullscreenCuepointPreviews) => showFullscreenCuepointPreviews,
);
